import axiosInstance from "../../axiosInstance";

const createJournal = async (data) => {
  try {
    const res = await axiosInstance.post(`/api/journal/create`, data);

    if (res.status === 201) {
      return res.data;
    } else {
    }
  } catch (error) {}
};

export default createJournal;
